import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { removeNullFields } from "../../../../common/mapper";
import { PaymentStatus } from "../../common/constants";
import Filter from "../common/filter";
import TabBKKBelumLengkap from "./tabBKKBelumLengkap";
import TabBKKBelumRealisasi from "./tabBKKBelumRealisasi";
import TabBKKRealisasi from "./tabBKKRealisasi";
import M from "moment";
import * as R from "ramda";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class TabBKK extends Component {
  constructor(props) {
    super(props);
    this.initialSearchData = {
      startPaymentDate: M().format("DD-MM-YYYY"),
      endPaymentDate: M().format("DD-MM-YYYY"),
    };
    this.initialPagination = {
      totalData: 1,
      page: 1,
      limit: 5,
    };
    this.state = {
      tabIndex: 0,
      loading: false,
      filterVisible: false,
      filterData: {},
      searchData: this.initialSearchData,
      submittedFilterData: {},
      skipNextPaginationFetch: false,
      dataTable: [],
      pagination: this.initialPagination,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tabIndex !== this.state.tabIndex) {
      this.refetch({
        ...this.initialSearchData,
      });
    }
    const { submittedFilterData, pagination, skipNextPaginationFetch } =
      this.state;
    if (
      (prevState.pagination.page !== pagination.page ||
        prevState.pagination.limit !== pagination.limit) &&
      !this.state.skipNextPaginationFetch
    ) {
      this.fetchData(submittedFilterData, pagination.page, pagination.limit);
    }
    if (skipNextPaginationFetch) {
      this.setState({ skipNextPaginationFetch: false });
    }

    if (prevProps.kodeCabang?.value !== this.props.kodeCabang?.value) {
      this.handleResetPeriode();
      this.handleResetPagination();
      this.fetchData({
        ...submittedFilterData,
        ...this.initialSearchData,
      });
    }
  }

  fetchData = async (
    filter = {},
    page = this.state.pagination.page,
    limit = this.state.pagination.limit,
  ) => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: true,
      submittedFilterData: filter,
    }));

    const payload = {
      kodeCabang: this.props.kodeCabang?.value || "",
      paymentStatus: PaymentStatus.BELUM_LENGKAP,
      ...filter,
      operator: filter?.operator ? filter.operator.value : null,
      jenisRelasi: filter?.jenisRelasi ? filter.jenisRelasi.value : null,
      jenisDokumen: filter?.jenisDokumen ? filter.jenisDokumen.value : null,
      kodeKas: filter?.kodeKas ? filter.kodeKas.value : null,
    };

    if (this.state.tabIndex === 2) {
      payload.startPaymentRealizationDate = payload.startPaymentDate;
      payload.endPaymentRealizationDate = payload.endPaymentDate;
      delete payload.startPaymentDate;
      delete payload.endPaymentDate;
    }
    const response = await Api.create("NAGAMAS_TRANSACTION").getBKKData({
      paramFilters: removeNullFields(payload),
      limit,
      page,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      const total = response.data.data.reduce(
        (sum, item) => sum + (item.paymentAmount || 0),
        0,
      );
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: response.data.data,
        totalPayment: total,
        pagination: {
          ...prevValue.pagination,
          totalData: response.data.totalData,
          limit: limit,
          page: page,
        },
      }));
    }
    this.setState({ loading: false });
  };

  handleTabChange = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      tabIndex: index,
      filterData: {},
      searchData: this.initialSearchData,
    }));
    this.handleResetPagination();
  };

  handlePeriodChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: M(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleSubmitPeriod = () => {
    this.setState({ skipNextPaginationFetch: true });
    this.handleResetPagination();

    let { searchData } = this.state;
    const paymentDate = removeNullFields({
      startPaymentDate: R.isNil(searchData.startPaymentDate)
        ? null
        : searchData.startPaymentDate,
      endPaymentDate: R.isNil(searchData.endPaymentDate)
        ? null
        : searchData.endPaymentDate,
    });
    this.setState((prevValue) => ({ ...prevValue, filterData: {} }));
    this.refetch(paymentDate);
  };

  handleSubmitFilter = async () => {
    this.handleResetPagination();
    this.handleResetPeriode();
    this.setState((prevValue) => ({ ...prevValue, searchData: {} }));
    let {
      tanggalPayment,
      tanggalDokumenRef1,
      tanggalDokumenRef2,
      gunaMembayar,
      nomorDokumenRef1,
      nomorDokumenRef2,
      kodeKas,
      keterangan,
      jenisRelasi,
      jenisDokumen,
      namaOrangTransaksi,
      ...rest
    } = this.state.filterData;
    const paymentDate = removeNullFields(
      this.getPeriodInput(tanggalPayment, "payment"),
    );
    const tanggalDocRef1 = removeNullFields(
      this.getPeriodInput(tanggalDokumenRef1, "docRef1"),
    );
    const tanggalDocRef2 = removeNullFields(
      this.getPeriodInput(tanggalDokumenRef2, "docRef2"),
    );

    await this.refetch(
      removeNullFields({
        ...rest,
        ...paymentDate,
        ...tanggalDocRef1,
        ...tanggalDocRef2,
        paymentPurpose: gunaMembayar,
        documentRef1No: nomorDokumenRef1,
        documentRef2No: nomorDokumenRef2,
        cashCode: kodeKas?.value,
        note: keterangan,
        paymentRelationType: jenisRelasi?.value,
        transactionPersonName: namaOrangTransaksi,
        documentType: jenisDokumen?.value,
      }),
    );
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: false,
      searchData: {
        startPaymentDate: null,
        endPaymentDate: null,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState((prevValue) => ({ ...prevValue, filterData: {} }));
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleFilterDateChange = (key, name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [key]: {
          ...prevValue.filterData[key],
          [name]: value,
        },
      },
    }));
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  refetch = async (filter = {}) => {
    const { pagination } = this.state;

    const paymentStatus =
      this.state.tabIndex === 0
        ? PaymentStatus.BELUM_LENGKAP
        : this.state.tabIndex === 1
          ? PaymentStatus.BELUM_REALISASI
          : PaymentStatus.REALISASI;

    await this.fetchData(
      { ...filter, paymentStatus },
      pagination.page,
      pagination.limit,
    );

    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilterData: { ...filter, paymentStatus },
    }));
  };

  getPeriodInput = (data, type) => {
    if (type === "payment") {
      return {
        startPaymentDate: R.isNil(data?.tanggalAwal)
          ? null
          : M(data?.tanggalAwal).format("DD-MM-YYYY"),
        endPaymentDate: R.isNil(data?.tanggalAkhir)
          ? null
          : M(data?.tanggalAkhir).format("DD-MM-YYYY"),
      };
    }
    if (type === "docRef1") {
      return {
        startDocumentRef1Date: R.isNil(data?.tanggalAwal)
          ? null
          : M(data?.tanggalAwal).format("DD-MM-YYYY"),
        endDocumentRef1Date: R.isNil(data?.tanggalAkhir)
          ? null
          : M(data?.tanggalAkhir).format("DD-MM-YYYY"),
      };
    }
    if (type === "docRef2") {
      return {
        startDocumentRef2Date: R.isNil(data?.tanggalAwal)
          ? null
          : M(data?.tanggalAwal).format("DD-MM-YYYY"),
        endDocumentRef2Date: R.isNil(data?.tanggalAkhir)
          ? null
          : M(data?.tanggalAkhir).format("DD-MM-YYYY"),
      };
    }
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleResetPeriode = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: this.initialSearchData,
    }));
  };

  handleResetPagination = (resetPage = true) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: resetPage ? 1 : prevValue.pagination.page,
        limit: prevValue.pagination.limit,
        totalData: prevValue.pagination.totalData,
      },
      skipNextPaginationFetch: true,
    }));
  };

  handleRefresh = () => {
    const { page, limit } = this.state.pagination;
    const { submittedFilter } = this.state;
    
    this.fetchData(submittedFilter, page, limit);
  };

  render() {
    return (
      <div>
        <Tabs
          selectedIndex={this.state.tabIndex}
          onSelect={this.handleTabChange}
        >
          <TabList>
            <Tab>BELUM LENGKAP</Tab>
            <Tab>BELUM REALISASI</Tab>
            <Tab>REALISASI</Tab>
          </TabList>
          <TabPanel>
            <TabBKKBelumLengkap
              {...this.props}
              refetch={this.refetch}
              submittedFilter={this.state.submittedFilterData}
              state={this.state}
              onRefresh={this.handleRefresh}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
          <TabPanel>
            <TabBKKBelumRealisasi
              {...this.props}
              refetch={this.refetch}
              submittedFilter={this.state.submittedFilterData}
              state={this.state}
              onRefresh={this.handleRefresh}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
          <TabPanel>
            <TabBKKRealisasi
              {...this.props}
              refetch={this.refetch}
              submittedFilter={this.state.submittedFilterData}
              state={this.state}
              onRefresh={this.handleRefresh}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
        </Tabs>
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
        {this.state.filterVisible && (
          <Filter
            {...this.props}
            tab="BKK"
            data={this.state.filterData}
            visible={this.state.filterVisible}
            onClickClose={this.handleFilterVisibility}
            onValueChange={this.handleFilterValueChange}
            onDateChange={this.handleFilterDateChange}
            onSubmit={this.handleSubmitFilter}
            onClear={this.handleClearFilter}
          />
        )}
      </div>
    );
  }
}

export default TabBKK;
